import { createFileRoute, Outlet } from '@tanstack/react-router'
import { FooterViewModel } from '@/components/shared/footer/footer.view-model'
import { NavbarViewModel } from '@/components/shared/navbar/navbar.view-model'

export const Route = createFileRoute('/_editorial')({
  component: EditorialLayout,
})

function EditorialLayout() {
  return (
    <>
      <NavbarViewModel variant="editorial" />
      <main>
        <Outlet />
      </main>
      <FooterViewModel />
    </>
  )
}
